module.exports = __webpack_public_path__ + "img/ic_combine.2f89fbc0.svg";